import { useQuery } from '@tanstack/react-query'
import { fetchApiWithToken } from '~/api/utils'
import type { AttachmentResponse } from '~/domains/attachments/types'

export type ApplicantAttachmentResponse = AttachmentResponse & {
  defaultResume?: boolean
}

export const useApplicantAttachments = ({
  applicantId
}: {
  applicantId?: number
}) => {
  return useQuery({
    queryKey: ['applicants', applicantId, 'attachments'],
    queryFn: async () => {
      if (!applicantId) return null
      return await fetchApiWithToken<ApplicantAttachmentResponse[]>({
        method: 'get',
        url: `/v1/applicants/${applicantId}/attachments`
      })
    },
    enabled: !!applicantId,
    staleTime: 300_000,
    refetchOnWindowFocus: false
  })
}

export const useApplicantAttachmentContent = ({
  attachmentId,
  enabled = true
}: {
  attachmentId: number
  enabled?: boolean
}) => {
  return useQuery({
    queryKey: ['attachments', attachmentId, 'content'],
    queryFn: async () =>
      fetchApiWithToken<ApplicantAttachmentResponse>({
        method: 'get',
        url: `/v1/attachments/${attachmentId}`
      }),
    enabled: enabled && !!attachmentId,
    staleTime: Number.POSITIVE_INFINITY,
    refetchOnWindowFocus: false
  })
}
